<template>
  <n-config-provider>
    <div
      class="w-full min-h-screen mx-auto flex items-center justify-center antialiased"
    >
      <slot />
    </div>
  </n-config-provider>
</template>
